module.exports = __webpack_public_path__ + "static/media/Greg Gruber Headshot.bebbe880.jpg";